// Generated by https://quicktype.io

export interface GetStoreResponseI {
    status: number;
    single: Single;
}

export interface Single {
    data_sheet:             DataSheet;
    vouchers:               any[];
    perfect_store:          PerfectStore[];
    forms_users:            FormsUser[];
    forms_pos:              FormsPo[];
    get_answers_ejecutions: GetAnswersEjecution[];
}

export interface DataSheet {
    _id:                           string;
    history_check_in:              HistoryCheckIn[];
    additional:                    Additional[];
    code:                          string;
    name:                          string;
    lat:                           string;
    lng:                           string;
    address:                       string;
    maximum_distance_for_checking: number;
    fields:                        any[];
    cluster:                       string;
    area:                          string;
    region:                        string;
    format:                        string;
    flag:                          string;
    retailer:                      string;
}

export interface Additional {
    id:    string;
    label: string;
    value: string;
}

export interface HistoryCheckIn {
    duration:       string;
    date:           string;
    user:           string;
    user_last_name: null | string;
    id_check_in:    string;
}

export interface FormsPo {
    _id:          string;
    repeat:       boolean;
    can_repeat:   boolean;
    index_form:   number;
    name_form:    string;
    icon:         string;
    check_in:     boolean;
    type_form:    Type;
    icon_check:   string;
    segments:     Segments;
    status:       number;
    tags:         any[];
    contents:     FormsPoContent[];
    show_barcode: boolean;
    progress:     boolean;
    totalScore:   number;
}

export interface FormsPoContent {
    _id:               string;
    media:             string;
    title:             string;
    description:       string;
    input_type:        InputType;
    secondary_actions: PurpleSecondaryAction[];
    status:            number;
    end_ejecution:     string;
    start_ejecution:   string;
    questionScore:     number;
    code:              string;
    tag:               ContentTag;
    active?:           boolean;
}

export interface InputType {
    _id:           string;
    title:         string;
    type:          number;
    label?:        string;
    benefit_type?: boolean;
}

export interface PurpleSecondaryAction {
    fields:           string[];
    label:            QuestionOptionSelectedText;
    form?:            Form[];
    _id:              string;
    equipo_code?:     string;
    serie_code?:      string;
    refrigerator_id?: string;
}

export interface Form {
    name_activity:     string;
    type_form:         Type;
    index:             number;
    checkin_necessary: boolean;
    icon_check:        string;
    icon:              string;
    contents:          FormContent[];
    _id:               string;
    refrigerator_id?:  string;
}

export interface FormContent {
    _id:               string;
    media:             string;
    title:             string;
    description:       string;
    input_type:        InputType;
    secondary_actions: FluffySecondaryAction[];
    status:            number;
    start_ejecution:   string;
    end_ejecution:     string;
    index?:            number;
    questionInput?:    string;
}

export interface FluffySecondaryAction {
    _id:    string;
    action: number;
    label:  string;
    fields: Field[];
}

export interface Field {
    label:    string;
    type:     Type;
    required: boolean;
    options:  any[];
}

export interface Type {
    _id:           string;
    title:         string;
    type:          number;
    date_created?: string;
}

export enum QuestionOptionSelectedText {
    DotsTestDotsCOMTestTest = "dots_test@dots.com - test test",
    No = "no",
    Yes = "yes",
}

export interface ContentTag {
}

export interface Segments {
    countries: any[];
    areas:     any[];
    roles:     any[];
    regions:   any[];
    clusters:  any[];
    retailers: any[];
    formats:   any[];
    idioms:    any[];
    pos:       string[];
}

export interface FormsUser {
    form_id:          string;
    secondary_action: any[];
}

export interface GetAnswersEjecution {
    _id:           string;
    name_activity: string;
    status:        number;
    id_activity:   string;
    name_store:    string;
    code:          string;
    address:       string;
    name_user:     string;
    id_user:       string;
    date_init:     string;
    date_finish:   string;
    score:         string;
    progress:      string;
    answers:       Answer[];
    timeZone:      string;
    id_pos:        string;
    id_checkin:    string;
    __v:           number;
}

export interface Answer {
    _id:                        string;
    actionInputsAnswer:         any[];
    actionOptionsSelected:      any[];
    formAnswers:                any[];
    questionOptionSelected:     string[];
    questionType:               QuestionType;
    question:                   string;
    date_init:                  string;
    date_finish:                string;
    questionOptionSelectedText: QuestionOptionSelectedText[];
    questionImage:              string;
    questionInput:              string;
    questionPrice:              string;
    formsAnswersQuestion:       any[];
    description:                string;
    score:                      string;
}

export interface QuestionType {
    title: QuestionTypeTitle;
    type:  number;
    id:    ID;
}

export enum ID {
    The6388F4F855Fb4C5388Dc24E8 = "6388f4f855fb4c5388dc24e8",
    The6595665Ff72Cdc1Cb920Efdf = "6595665ff72cdc1cb920efdf",
}

export enum QuestionTypeTitle {
    DropdownUsers = "dropdown_users",
    YesNo = "yes_no",
}

export interface PerfectStore {
    _id:            string;
    status:         number;
    index:          number;
    title:          string;
    icon:           string;
    medias:         Media[];
    type:           Type;
    tags?:          TagElement[];
    link_download?: string;
    show_barcode?:  boolean;
}

export interface Media {
    media:              string;
    media_url:          string;
    media_type:         MediaType;
    media_name:         string;
    description_short?: string;
    description?:       string;
    _id?:               string;
    title?:             MediaTitle;
    brand?:             string;
    description_long?:  string;
    tag?:               MediaTag;
    index?:             number;
    sku?:               string;
}

export enum MediaType {
    Image = "image",
}

export interface MediaTag {
    _id:   number;
    name:  string;
    media: string;
}

export enum MediaTitle {
    Empty = "",
    Precios = "Precios",
}

export interface TagElement {
    _id:  number;
    name: string;
}
